export const invoicePageHeaderPresentation = {
  descriptionClassName: "mt-1.5 text-sm text-black whitespace-pre-line",
  descriptionStyle: { fontFamily: '"DM Sans", sans-serif' },
  titleClassName: "text-[28px] font-bold leading-[1.25] text-black",
  titleStyle: { fontFamily: '"DM Sans", sans-serif' },
} as const;

export const invoicePageLayoutPresentation = {
  ...invoicePageHeaderPresentation,
  containerClassName: "md:-mt-[16px]",
  headerSpacingClassName: "pt-[32px] pb-4",
  horizontalPaddingClassName: "px-4 md:px-10",
} as const;
